export default class AnomalyEvents {
  client

  constructor(client) {
    this.client = client
  }

  list(params, options = {}) {
    return this.client.post("/api/v2/anomaly_events/list", params, options)
  }
}
